{
  "name": "English",
  "code": "en",
  "messages": {
    "alert": {
      "title": "Confirm",
      "confirm": "OK",
      "cancel": "Cancel"
    },
    "autocomplete": {
      "clear": "Clear",
      "loading": "Loading…",
      "noResult": "No matching options"
    },
    "avatar": {
      "unknownUser": "Unknown user"
    },
    "avatarGroup": {
      "label": "{count} users"
    },
    "carousel": {
      "label": "Carousel",
      "prev": "Previous slide",
      "next": "Next slide",
      "nav": "Carousel navigation",
      "goto": "Go to slide {index}"
    },
    "chip": {
      "remove": "Remove"
    },
    "commandPalette": {
      "placeholder": "Search…",
      "empty": "Type to search",
      "noResult": "No results",
      "loading": "Loading…",
      "close": "Close",
      "hintSelect": "Select",
      "hintOpen": "Open",
      "hintClose": "Close",
      "resultCount": "{count} results"
    },
    "copy": {
      "copied": "Copied",
      "success": "Copied {text}",
      "failure": "Could not copy {text} — your browser blocked clipboard access."
    },
    "datePicker": {
      "placeholderDay": "Select a date",
      "placeholderMonth": "Select a month",
      "placeholderYear": "Select a year",
      "clear": "Clear",
      "today": "Today",
      "close": "Close",
      "prevYear": "Previous year",
      "nextYear": "Next year",
      "prevPage": "Previous {unit}",
      "nextPage": "Next {unit}",
      "zoomOut": "{label} — zoom out",
      "unitMonth": "month",
      "unitYear": "year",
      "unitDecade": "decade",
      "monthCell": "{month} {year}"
    },
    "drawer": {
      "close": "Close drawer"
    },
    "fileInput": {
      "trigger": "Choose files",
      "selected": "{count} files selected"
    },
    "filePicker": {
      "tooLarge": "{name} exceeds the {size} size limit"
    },
    "input": {
      "clear": "Clear",
      "reveal": "Show password",
      "hide": "Hide password"
    },
    "lightbox": {
      "label": "Image viewer",
      "close": "Close",
      "prev": "Previous image",
      "next": "Next image",
      "goto": "Go to image {index}",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "rotateLeft": "Rotate 90° left",
      "rotateRight": "Rotate 90° right",
      "reset": "Reset zoom, rotation and position",
      "download": "Download"
    },
    "lightboxGallery": {
      "view": "View full size"
    },
    "loading": {
      "description": "Loading…"
    },
    "loli": {
      "close": "Close"
    },
    "message": {
      "close": "Close"
    },
    "modal": {
      "close": "Close"
    },
    "null": {
      "description": "Nothing here yet"
    },
    "numberInput": {
      "decrement": "Decrease",
      "increment": "Increase"
    },
    "pagination": {
      "nav": "Pagination",
      "prev": "Previous page",
      "next": "Next page",
      "page": "Page {page}",
      "hintBefore": "Use",
      "hintAfter": "to turn pages quickly",
      "jumpLabel": "Go to page",
      "jump": "Go"
    },
    "pinInput": {
      "label": "Verification code",
      "digit": "{label} digit {index}"
    },
    "reaction": {
      "label": "Like"
    },
    "select": {
      "searchPlaceholder": "Search…",
      "noResult": "No matching options",
      "loading": "Loading…",
      "clear": "Clear",
      "removeOption": "Remove {label}"
    },
    "spoiler": {
      "copyCode": "Copy code",
      "reveal": "Spoiler — click or press Enter to reveal"
    },
    "tagInput": {
      "tag": "Tag {tag}",
      "removeTag": "Remove tag {tag}"
    },
    "upload": {
      "imageAlt": "Uploaded image",
      "cropTitle": "Crop image",
      "cancel": "Cancel",
      "confirm": "OK"
    }
  }
}
